import { Route, Redirect } from "react-router-dom";
import { getCurrentUser } from "../../services/auth";

const ProtectedRoute = ({
	path,
	component: Component,
	userRole,
	render,
	...rest
}) => {
	const user = getCurrentUser();
	return (
		<Route
			{...rest}
			render={(props) => {
				if (!user || !Object.keys(user).length) {
					return (
						<Redirect
							to={{
								pathname: "/admin/login",
								state: { from: props.location },
							}}
						/>
					);
				}
				if (userRole && user.role !== userRole) {
					return (
						<Redirect
							to={{
								pathname: "/admin/login",
								state: { from: props.location },
							}}
						/>
					);
				}
				return Component ? <Component {...props} /> : render(props);
			}}
		/>
	);
};

export default ProtectedRoute;
